<template>
  <b-card>
    <div class="d-flex justify-content-between mb-3">
      <h3>{{ isEditing ? "Editar usuário" : "Novo usuário" }}</h3>
    </div>

    <b-modal
      ref="feedbackModal"
      title="Atenção"
      ok-only
      ok-title="Entendi"
      centered
    >
      {{ feedback.text }}
    </b-modal>

    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <b-col md="3">
          <b-form-group label="E-mail">
            <b-form-input
              v-model="form.email"
              :disabled="isEditing"
              required
              placeholder="Digite o e-mail do usuário"
            />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group label="Nome">
            <b-form-input
              v-model="form.name"
              required
              placeholder="Digite o nome do usuário"
            />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group label="EC">
            <div class="ec-autocomplete" ref="ecAutocomplete">
              <b-form-input
                @focus="fetchEcs"
                v-model="ecSearch"
                placeholder="Digite para buscar EC..."
                @input="fetchEcs"
                @blur="validateEcInput"
                 @keydown.enter.prevent="handleEnterEc"
              />

              <div v-if="ecSuggestions.length" class="ec-dropdown">
                <div
                  v-for="ec in ecSuggestions"
                  :key="ec.id"
                  class="ec-item"
                  @click="selectEc(ec)"
                >
                  {{ ec.name }}
                </div>
              </div>
            </div>

            <div v-if="form.ecs.length" class="ecs-box mt-2">
              <div class="ecs-summary">
                <b-badge
                  v-for="ec in form.ecs"
                  :key="ec"
                  class="mr-1 mb-1"
                  variant="primary"
                >
                  {{ getEcName(ec) }}
                  <span
                    @click="removeEc(ec)"
                    class="cursor-pointer ml-1"
                  >
                    ✕
                  </span>
                </b-badge>
              </div>
            </div>
          </b-form-group>
        </b-col>

        <b-col
          md="3"
          v-if="canSeeAdminSwitch"
        >
          <div class="permission-item mt-2">
            
            <div class="d-flex align-items-center">
              <span> É Administrador?</span>
            </div>

            <b-form-checkbox
              v-model="form.isAdmin"
              switch
            />
            
          </div>
        </b-col>
      </b-row>
      <hr>
      <b-form-group class="mt-1">
      <template #label>
        <h4 class="mb-0">Permissões</h4>
      </template>
        <div class="permissions-grid">
          <div
            v-for="option in permissionOptions"
            :key="option.value"
            class="permission-item"
          >
            <div class="d-flex align-items-center gap-1 ">
              <div class="d-flex align-items-center mr-1">
              <feather-icon
                :icon="iconMap[option.value]"
                size="16"
                class="mr-1"
              />
              <span>{{ option.text }}</span>
            </div>

              <HelpCircleIcon
                :id="`tooltip-${option.value}`"
                class="text-muted"
                style="width:16px; height:16px; cursor: pointer"
              />

              <b-tooltip
                :target="`tooltip-${option.value}`"
                placement="top"
              >
                {{ option.description }}
              </b-tooltip>
            </div>

            <b-form-checkbox
              v-model="form.permissions"
              :value="option.value"
              switch
            />
          </div>
        </div>
      </b-form-group>

      <div class="d-flex justify-content-end mt-3">
        <b-button
          v-if="isEditing"
          variant="secondary"
          class="mr-2"
          @click="$emit('cancel')"
        >
          Cancelar
        </b-button>

       <b-button
        type="submit"
        variant="primary"
        :disabled="loading"
      >
        <b-spinner small v-if="loading" class="mr-1" />
        {{ loading ? (isEditing ? "Salvando..." : "Criando...") : (isEditing ? "Salvar" : "Criar") }}
      </b-button>
      </div>
    </b-form>
    <b-modal
    centered
    ref="removeEcModal"
    title="Remover EC"
    @ok="confirmRemoveEc"
    ok-title="Remover"
    ok-variant="danger"
    cancel-title="Cancelar"
  >
    <p>
      Tem certeza que deseja remover o EC
      <strong>{{ ecToRemove }}</strong>
      deste usuário?
    </p>
  </b-modal>
  </b-card>
</template>
<script>
import {
  BCard,
  BSpinner,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckboxGroup,
  BButton,
  BAlert,
  BFormCheckbox,
  BListGroup,
  BListGroupItem,
  BBadge,
  BRow,
  BCol,
  BModal
} from "bootstrap-vue";
import { HelpCircleIcon } from 'vue-feather-icons'
import { BTooltip } from 'bootstrap-vue'
import { PERMISSIONS } from '@/enums/permissions'
export default {
  props: ["form", "isEditing", "feedback", "permissionOptions", "allEcs", "myPermissions", "loading"],

  components: {
    BCard,
    BForm,
    BFormGroup,
    BSpinner,
    BFormInput,
    BFormCheckboxGroup,
    BFormCheckbox,
    BButton,
    BAlert,
    BListGroup,
    BListGroupItem,
    BBadge,
    BRow,
    BCol,
    HelpCircleIcon,
    BTooltip,
    BModal,  
  },

  data() {
    return {
      ecSearch: "",
      ecToRemove: null,
      ecSuggestions: [],
      iconMap: {
        162: 'TrendingUpIcon',
        163: 'FolderIcon',
        164: 'DollarSignIcon',
        165: 'UsersIcon',
        166: 'FileTextIcon',
        167: 'ArchiveIcon'
      }
    };
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },

  computed: {
    canSeeAdminSwitch() {
      return this.myPermissions?.includes(PERMISSIONS.MASTER)
    },
  },

  methods: {
    fetchEcs() {
      const search = this.ecSearch?.toLowerCase() || ''

      if (!search) {
        this.ecSuggestions = this.allEcs
        return
      }

      this.ecSuggestions = this.allEcs.filter(ec =>
        ec.name.toLowerCase().includes(search)
      )
    },

    handleClickOutside(event) {
      const el = this.$refs.ecAutocomplete

      if (!el) return

      if (!el.contains(event.target)) {
        this.ecSuggestions = []
      }
    },
    
    handleSubmit() {
      if (!this.form.permissions || this.form.permissions.length === 0) {
        this.showFeedback('Selecione pelo menos uma permissão para criar um novo usuário.')
        return
      }

      if (!this.form.ecs || this.form.ecs.length === 0) {
        this.showFeedback('Selecione pelo menos um EC para criar um novo usuário.')
        return
      }

      this.$emit('save')
    },

    handleEnterEc() {
      if (!this.ecSearch) return

      const search = this.ecSearch.toLowerCase()

      const exactNumber = this.allEcs.find(
        ec => String(ec.value) === search
      )

      if (exactNumber) {
        this.selectEc(exactNumber)
        return
      }

      const exactName = this.allEcs.find(
        ec => ec.name.toLowerCase() === search
      )

      if (exactName) {
        this.selectEc(exactName)
        return
      }

    if (this.ecSuggestions.length) {
        this.selectEc(this.ecSuggestions[0])
        return
      }

    this.showFeedback(
      'Esse estabelecimento não está cadastrado na sua base. Por favor, peça ao atendimento.'
    )

      this.ecSearch = ''
      this.ecSuggestions = []
    },

    showFeedback(text) {
      this.feedback.text = text
      this.$refs.feedbackModal.show()
    },

    validateEcInput() {
      if (!this.ecSearch) return

      const search = this.ecSearch.toLowerCase()

      const exists = this.allEcs.some(ec =>
        ec.name.toLowerCase() === search ||
        String(ec.value) === search
      )

      if (!exists) {
        this.showFeedback(
          'Esse EC não está cadastrado na sua base. Por favor, peça ao atendimento.'
        )

        this.ecSearch = ''
        this.ecSuggestions = []
      }
    },

    selectEc(ec) {
      if (!this.form.ecs.includes(ec.value)) {
        this.form.ecs.push(ec.value)
      }

      this.ecSearch = ''
      this.ecSuggestions = []
    },
    
    getEcName(ecValue) {
    const found = this.allEcs.find(e => e.value === ecValue);
    return found ? found.name : ecValue;
    },

    removeEc(ec) {
      this.ecToRemove = ec
      this.$refs.removeEcModal.show()
    },

    confirmRemoveEc() {
      this.form.ecs = this.form.ecs.filter(
        item => item !== this.ecToRemove
      )

      this.ecToRemove = null
    },
  },
};
</script>

<style scoped>
.permissions-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

@media (min-width: 768px) {
  .permissions-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1200px) {
  .permissions-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.permission-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

.permission-label {
  font-size: 14px;
}

.permission-switch {
  margin-bottom: 0 !important;
}

.permission-switch .custom-control-label {
  margin-bottom: 0;
}


.ec-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 999;

  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  max-height: 200px;
  overflow-y: auto;
}

.ec-item {
  padding: 8px 12px;
  cursor: pointer;
}

.ecs-container {
  max-height: 80px;     
  overflow-y: auto;      
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.ec-autocomplete {
  position: relative;
}

.ec-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #d8d6de;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
}

.ec-item {
  padding: 8px 12px;
  cursor: pointer;
}

.ec-item:hover {
  background-color: #f3f2f7;
}

.ecs-box {
  max-height: 110px;
  overflow-y: auto;
  padding-right: 4px;
}

.ecs-box::-webkit-scrollbar {
  width: 4px;
}

.ecs-box::-webkit-scrollbar-thumb {
  background: #d8d6de;
  border-radius: 4px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>